import { Text3, IconWarningRegular, Stack, skinVars, useDialog } from '@telefonica/mistica';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getEnv } from '../../utils/dataTransformation/environments';

export enum EErrorAlert {
    UNKNOW_USER = 'unknow_user',
    ERROR_GENERIC = 'error_generic',
}

export interface IManagementErrorAlert {
    type?: EErrorAlert;
    fromMC?: boolean;
}

export const ManagementErrorAlert: React.FC<IManagementErrorAlert> = ({ type, fromMC }: IManagementErrorAlert) => {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const state = params.get('state');
    const { t } = useTranslation();
    const { dialog } = useDialog();

    const launchAlert = () => {
        const literals: { [key: string]: any } = {
            unknow_user: {
                title: t('supportErrorProblemsTitle'),
                description: 'El número introducido es inválido.',
            },
            error_generic: {
                title: t('supportErrorProblemsTitle'),
                description: t('errorGenericDescription'),
            },
        };

        const getLiteralsType = (type: string) => {
            return literals[type];
        };

        let message = {
            title: getLiteralsType(type as string)?.title,
            description: getLiteralsType(type as string)?.description,
        };

        dialog({
            asset: <IconWarningRegular color={skinVars.colors.feedbackErrorBackground} size={64} />,
            title: message.title,
            message: (() => {
                return (
                    <Stack space={16}>
                        <Text3 light color={skinVars.colors.borderHigh}>
                            {message.description}
                        </Text3>
                    </Stack>
                );
            })() as any,
            acceptText: t('buttonUnderstoodFeedback'),
            onAccept: () => {
                window.localStorage.clear();
                window.sessionStorage.clear();
                if (fromMC) {
                    navigate(`/login/mc?client_id=${getEnv('VITE_CLIENT_ID')}&state=${state}`);
                } else {
                    navigate('/login');
                }
            },
        });
    };

    useEffect(() => {
        launchAlert();
    }, []);

    return <></>;
};

export default ManagementErrorAlert;
